/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PaymentDetailsPage } from 'gw-capability-quoteandbind-common-react';
import { PolicyInfoPage, PolicyDetailsPage, OfferingsPage, LocationsPage, DeclarationPage, RiskAnalysisPage, SuccessPage} from 'premier-capability-policyjob-react';
import InfoPage from './pages/Info/InfoPage';
import QuotePage from './pages/Quote/QuotePage';
import EquipmentBreakdownPage from './pages/EquipmentBreakdown/EquipmentBreakdownPage';
import LiabilityCoveragesPage from './pages/LiabilityCoverages/LiabilityCoveragesPage';
import BuildersRiskPage from './pages/BuildersRisk/BuildersRiskPage'
import CodegenWizard from './CodegenWizard';

import { CodegenContext } from './components/CodegenContext';
import PropertyCoveragesPage from './pages/PropertyCoverages/PropertyCoveragesPage';
import PropertyPage from './pages/Property/PropertyPage';



setComponentMapOverrides(
    {
        // wizard pages
        PremierOfferingsPage: { component: 'PremierOfferingsPage'},
        PremierCTPolicyDetailsPage: { component: 'PremierCTPolicyDetailsPage'},
        PremierCTLocationsPage: { component: 'PremierCTLocationsPage'},
        PremierCTInfoPage: { component: 'PremierCTInfoPage' },
        PremierCTLiabilityCoveragesPage: { component: 'PremierCTLiabilityCoveragesPage' },
        PremierCTQuotePage: { component: 'PremierCTQuotePage' },
        PremierCTPolicyInfoPage: { component: 'PremierCTPolicyInfoPage' },
        PremierCTPaymentDetailsPage: { component: 'PremierCTPaymentDetailsPage' },
        PremierCTSuccessPage: { component: 'PremierCTSuccessPage' },
        PremierCTDeclarationPage: { component: 'PremierCTDeclarationPage'},
        PremierCTRiskAnalysisPage: { component: 'PremierCTRiskAnalysisPage'},
        PremierCTEquipmentBreakdownPage: { component: 'PremierCTEquipmentBreakdownPage'},
        PremierCTBuildersRiskPage: { component: 'PremierCTBuildersRiskPage'},
        PremierCTPropertyPage: { component: 'PremierCTPropertyPage'},
        PremierCTPropertyCoveragesPage: { component: 'PremierCTPropertyCoveragesPage'}
    },
    {
        // wizard pages
        PremierOfferingsPage: OfferingsPage,
        PremierCTPolicyDetailsPage: PolicyDetailsPage,
        PremierCTLocationsPage: LocationsPage,
        PremierCTInfoPage: InfoPage,
        PremierCTPropertyPage: PropertyPage,
        PremierCTPropertyCoveragesPage: PropertyCoveragesPage,
        PremierCTLiabilityCoveragesPage: LiabilityCoveragesPage,
        PremierCTEquipmentBreakdownPage: EquipmentBreakdownPage,
        PremierCTBuildersRiskPage : BuildersRiskPage,
        PremierCTQuotePage: QuotePage,
        PremierCTPolicyInfoPage: PolicyInfoPage,
        PremierCTPaymentDetailsPage: PaymentDetailsPage,
        PremierCTSuccessPage: SuccessPage,
        PremierCTDeclarationPage : DeclarationPage,
        PremierCTRiskAnalysisPage: RiskAnalysisPage,
    }
);
export { CodegenWizard, CodegenContext };
